import React from 'react';

import purplePencilIcon from '../../../assets/img/purplePencil.png';
import redZIcon from '../../../assets/img/redZ.png';
import greenZIcon from '../../../assets/img/greenZ.png';
import yellowZIcon from '../../../assets/img/yellowZ.png';
import purpleBellIcon from '../../../assets/img/purpleBell.png';

function compareSignsLength(item) {
  const warningSignsCount = Array.isArray(item.warning_signs)
    ? item.warning_signs.length
    : 0;
  const goodSignsCount = Array.isArray(item.good_signs)
    ? item.good_signs.length
    : 0;
  if (item.life_event?.length > 0) {
    return purplePencilIcon;
  } else if (warningSignsCount > goodSignsCount) {
    return redZIcon;
  } else if (goodSignsCount > warningSignsCount) {
    return greenZIcon;
  } else if (warningSignsCount === goodSignsCount && warningSignsCount !== 0) {
    return yellowZIcon;
  }
  return null;
}

function WellbeingFeedbackIcons(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  ) {
    const iconFile = compareSignsLength(props.item);

    if (iconFile) {
      return (
        <img
          src={iconFile}
          alt="wellbeing icon"
          className="wellbeing-timelineIcon"
        />
      );
    } else if (props.item?.change_reasons?.length > 0) {
      return (
        <img
          src={purpleBellIcon}
          alt="wellbeing icon"
          className="wellbeing-timelineIcon"
        />
      );
    }
  }
  return null;
}

export { WellbeingFeedbackIcons };
